import { render } from "./city-list.vue?vue&type=template&id=6877f9a4"
import script from "./city-list.vue?vue&type=script&lang=js"
export * from "./city-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__